import React, { Component } from "react";
import moment from "moment";
import  _ from "lodash";
import { Form, Control} from "react-redux-form";
import PropTypes from "prop-types";
import {confirmAlert} from "react-confirm-alert";
import {formatMoney} from "accounting-js";

const propTypes = {
	conclusion: PropTypes.object.isRequired,
	version: PropTypes.object.isRequired,
	permissions: PropTypes.array.isRequired,
	projectConclusionExport: PropTypes.func.isRequired,
	projectConclusionSave: PropTypes.func.isRequired
}

class ConclusionEditForm extends Component {
	render() {
		let { conclusion, match, permissions, version } = this.props;
		let agency = !_.isEmpty(conclusion.data) ? conclusion.data.agency:undefined;
		let owner = agency ? agency.owner:undefined;
		let conclusionRev = conclusion.revision && conclusion.revision.body && conclusion.revision.body ? conclusion.revision.body : undefined;
		//let conclusionDisabled = this._blockField();
		let conclusionDisabled = false;
		let pc = _.find(permissions, (o) => o === 'Create');
		return (
			<div className="columns">
				<div className="column">
					<div className="content">
						<blockquote>
							<h1 className="title is-6 has-text-weight-bold">INSTITUTO NACIONAL DE LAS MUJERES</h1>
							<h2 className="subtitle is-6">PRESENTE</h2>
							{/*<p>De acuerdo con lo señalado en la Convocatoria de ProEquidad {version.year} anexo el Formato de presentación de proyecto.</p>*/}
						</blockquote>
					</div>

					{(conclusionRev && !_.isEmpty(conclusionRev.comments)) &&
					<div className={`message ${conclusionRev.status ? 'is-'+conclusionRev.status : ''}`}>
						<div className="message-header">Comentarios</div>
						<div className="message-body">
							<div dangerouslySetInnerHTML={{__html: conclusionRev.comments}} />
						</div>
					</div>}

					<h1 className="title is-6">DATOS GENERALES</h1>
					<table className="table is-fullwidth project-goal-table no-margin">
						<tbody>
						<tr>
							<td>
								<span className="help is-dark">Titular</span>
								<strong>{owner ? `${owner.title} ${owner.name} ${owner.last_name} ${owner.slast_name}`:'---'}</strong>
							</td>
							<td>
								<span className="help is-dark">Localidad</span>
								<strong>{agency && agency.agenciable ? agency.agenciable.name : '---'}</strong>
							</td>
						</tr>
						<tr>
							<td colSpan={2}>
								<span className="help is-dark">Instancia</span>
								<strong>{agency ? agency.name : '---'}</strong>
							</td>
						</tr>
						<tr>
							<td colSpan={2}>
								<span className="help is-dark">Proyecto</span>
								<strong>{!_.isEmpty(conclusion.data) ? conclusion.data.name : '---'}</strong>
							</td>
						</tr>
						<tr>
							<td>
								<div className="columns">
									<div className="column is-1">
										<i className="fa fa-usd fa-2x" />
									</div>
									<div className="column">
										<span className="help is-dark">Monto proyecto</span>
										<strong>{formatMoney(!_.isEmpty(conclusion.data) ? conclusion.data.amounts.total:0)}</strong>
									</div>
								</div>
							</td>
							<td>
								<div className="columns">
									<div className="column is-1">
										<i className="fa fa-calendar fa-2x" />
									</div>
									<div className="column">
										<span className="help is-dark">Periodo de ejecución</span>
										<strong>{_.capitalize(moment(conclusion.data.execution_start).format('MMMM YYYY'))} a {_.capitalize(moment(conclusion.data.execution_end).format('MMMM YYYY'))}</strong>
									</div>
								</div>
							</td>
						</tr>
						</tbody>
					</table>

					<h1 className="title is-6">DATOS DEL PROYECTO</h1>
					<table className="table is-fullwidth project-goal-table no-margin">
						{!_.isEmpty(conclusion.data) && !_.isEmpty(conclusion.data.project_goals) ? _.map(conclusion.data.project_goals, (o, k) => {
							return (
								<tbody key={k}>
								<tr>
									<td className="goal-cell">
										<span className="help is-white">Código</span>
										<strong>{o.code}</strong>
									</td>
									<td style={{width:'50%'}}>
										<span className="help is-dark">Meta</span>
										<strong>{o.name}</strong>
									</td>
									<td>
										<span className="help is-dark">Documento meta</span>
										<small>{o.goal_document}</small>
									</td>
								</tr>
								<tr>
									<td colSpan={3}>
										{!_.isEmpty(o.project_goal_activities) ?
											<table className="table is-fullwidth project-activity-table">
												<thead>
												<tr>
													<th>ID</th>
													<th>Actividad</th>
													<th>Cantidad</th>
													<th>Total</th>
												</tr>
												</thead>
												<tbody>
												{_.map(o.project_goal_activities, (a, q) => {
													return (
														<tr key={q}>
															<td>{a.proigualdad_activity_id}</td>
															<td>{a.name}</td>
															<td>{a.quantity}</td>
															<td>{formatMoney(a.total)}</td>
														</tr>
													)
												})}
												</tbody>
											</table>
											: ''}
									</td>
								</tr>
								<tr>
									<td colSpan={2}>&nbsp;</td>
									<td className="has-text-right">
										<span className="help is-dark">Total</span>
										<strong>{formatMoney(o.total)}</strong>
									</td>
								</tr>
								</tbody>
							)
						}): <tbody>
								<tr>
									<td>Ninguna meta guardada</td>
								</tr>
							</tbody>}
					</table>

					<h1 className="title is-6">GASTOS DE COORDINACIÓN</h1>
					<table className="is-fullwidth table project-goal-table no-margin">
						{!_.isEmpty(conclusion.data) ?
							<tbody>
							{_.map(conclusion.data.project_expenses, (ex, k) => {
								return (
									<tr key={k}>
										<td>
											<span className="help is-dark">Num.</span>
											<strong>{k+1}</strong>
										</td>
										<td>
											<span className="help is-dark">Concepto de gasto</span>
											<span>{ex.expense_concept.name}</span>
										</td>
										<td>
											<span className="help is-dark">Cantidad</span>
											<span>{(ex.quantity).toFixed(0)}</span>
										</td>
										<td className="has-text-right">
											<span className="help is-dark">Monto</span>
											<span>{formatMoney(_.toNumber(ex.amount))}</span>
										</td>
										<td className="has-text-right">
											<span className="help is-dark">Total</span>
											<strong>{formatMoney(_.toNumber(ex.total))}</strong>
										</td>
									</tr>
								)
							})}
							</tbody>
						 :
						<tbody>
						<tr>
							<td>Ningún gasto de coordinación encontrado</td>
						</tr>
						</tbody>}
					</table>

					<h1 className="title is-6">RESUMEN DE GASTOS</h1>
					<table className="is-fullwidth table project-goal-table no-margin">
						<tbody>
						<tr>
							<td>
								<span className="help is-dark">Concepto</span>
								Gasto total del proyecto
							</td>
							<td className="has-text-right">
								<span className="help is-dark">Total</span>
									<strong>{ formatMoney(!_.isEmpty(conclusion.data) ? conclusion.data.amounts.goals.total:0)}</strong>
								</td>
						</tr>
						<tr>
							<td>
								<span className="help is-dark">Concepto</span>
								Gastos de coordinación
							</td>
							<td className="has-text-right">
								<span className="help is-dark">Total</span>
								<strong>{ formatMoney(!_.isEmpty(conclusion.data) ? conclusion.data.amounts.expenses.total:0)}</strong>
							</td>
						</tr>
						<tr>
							<td className="goal-cell">
								<span className="help is-white">Concepto</span>
								<span className="has-text-white">Monto total del proyecto</span>
							</td>
							<td className="goal-cell has-text-right">
								<span className="help is-white">Total</span>
								<strong>{ formatMoney(!_.isEmpty(conclusion.data) ? conclusion.data.amounts.total:0)}</strong>
							</td>
						</tr>
						</tbody>
					</table>

					<Form model="project.conclusion.data.documents" onSubmit={(project) => this._handleSubmit(project)} encType="multipart/form-data">

						{conclusion.data && !_.isEmpty(conclusion.data.last_document) ? <p className="title is-6 is-primary"><a href={conclusion.data.last_document.file} target="_blank">Ver resumen anterior</a></p> : ''}

						<div className="field is-grouped is-grouped-multiline">
							{_.map(_.filter(conclusion.documents_items, (o) => {return (o.modality_id === null || o.modality_id === (conclusion.data ? conclusion.data.modality_id:undefined))}),(item, d) => {
								let accepts = undefined;
								_.map(item.documents_types, (ext) => {
									accepts = accepts ? `${accepts},${ext.extensions}`:`${ext.extensions}`
								})
								return (
									<div className="control" key={d}>
										<div className={`file${!_.isEmpty(conclusion.data) && !_.isEmpty(conclusion.data.document) && conclusion.data.document[item.slug] ? ' is-success': ' is-warning'}`}>
											<label className="file-label">
												<Control.file className="file-input" model={`.${item.slug}`} id={`.${item.slug}`} accept={accepts} validateOn="change" disabled={conclusionDisabled}/>
												<span className="file-cta">
		                                            <span className="file-icon"><i className="fa fa-upload" /></span>
		                                            <span className="file-label">{item.name}</span>
		                                        </span>
											</label>

										</div>
										{!_.isEmpty(conclusion.data) && !_.isEmpty(conclusion.data.documents) && conclusion.data.documents[item.slug] ?
											!_.isObject(conclusion.data.documents[item.slug]) ?
												<a href={conclusion.data.documents[item.slug]} className="help is-success" target="_blank">
													1 documento guardado <i className="fa fa-external-link" aria-hidden="true"/>
												</a> :
												<p className="help is-info">Un nuevo archivo cargado</p>
											: ''}
										{item.file_format ?
											<a href={item.file_format} className="help is-info" target="_blank">
												Descargar formato <i className="fa fa-external-link" aria-hidden="true"/>
											</a>:''}
									</div>
								)
							})}

							<div className="control">
								<button type="button" className="button is-info" onClick={() => this.props.projectConclusionExport(match.params.modality, match.params.state, match.params.municipality )} disabled={conclusionDisabled}>
									<span className="icon"><i className="fa fa-link" /></span>
									<span>Generar resumen</span>
								</button>
							</div>
						</div>

							{!_.isEmpty(conclusion.data) && !_.isEmpty(conclusion.data.documents) ?
								<div className="message is-success">
									<div className="message-body">
										<div className="field">
											<div className="control">
												<label htmlFor="finished" className="checkbox">
													<Control.checkbox model="project.conclusion.finished" id="finished" className="checkbox"/>
													<span style={{whiteSpace:'normal'}}>{`He concluido el registro del proyecto y certifico que la información proporcionada es correcta y completa; conozco las disposiciones establecidas en las Bases de Participación del FOBAM ${version ? version.year:'----'}.`}</span>
												</label>
											</div>
										</div>
									</div>
								</div>
								: ''}

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-large" onClick={() => this.props.history.goBack()}>
									Regresar
								</button>
							</div>

							{pc ?
							<div className="control">
								<Control.button model="project.conclusion.data.documents" className="button is-large is-primary" disabled={!conclusion.editable}>Guardar</Control.button>
							</div>:''}
						</div>
					</Form>
				</div>
			</div>
		)
	}

    _handleSubmit(values, event) {
		const { modality, state, municipality } = this.props.match.params;
		if(values && this.props.conclusion.finished) {
			confirmAlert({
				title: '¿Esta seguro?',
				message: 'Si indicas que has terminado de guardar el proyecto, ya no lo podrás volver a editar. ¿Deseas continuar esta acción?',
				confirmLabel: 'Guardar',
				cancelLabel: 'Cancelar',
				onConfirm: () => this.props.projectConclusionSave(modality, state, municipality, {...values, finished: this.props.conclusion.finished}, event)
			});
		}
		else{
            this.props.projectConclusionSave(modality, state, municipality, values, event);
		}
	}

	_blockField() {
		let { conclusion } = this.props;
		let response = false;
		let editable = conclusion.editable;
		let conclusionRevision = !_.isEmpty(conclusion.revision) && conclusion.revision.body && conclusion.revision.body.document ? conclusion.revision.body.document : undefined;

		if(!_.isEmpty(conclusionRevision) && !conclusion.isFetching){
			let allow = conclusionRevision.allow_edit === 'true' ? true : false;
			if(editable && allow && !conclusion.finished){
				response = false;
			}else{
				response = true;
			}
		}else if(editable && !conclusion.isFetching && !conclusion.finished){
			response = false;
		}else {
			response = true;
		}

		return response;
	}
}

ConclusionEditForm.propTypes = propTypes;

export default ConclusionEditForm;



// WEBPACK FOOTER //
// ./src/elements/project/conclusion.jsx